(function () {
    'use strict';

    angular
        .module('app')
        .factory('searchService', searchService);

    searchService.$inject = ['$http', '$q'];

    function searchService($http, $q) {
        var service = {
            getResults: getResults,
            trackClick: trackClick

        };

        return service;

        function getResults(searchtext, types, sources, contenttypecategories, age, skip, take, sort, sortOrder, microsite, category) {
            var deferred = $q.defer();

            $http.get('/api/search/results', { params: { searchtext: searchtext, types: types, sources: sources, contenttypecategories: contenttypecategories, age: age, skip: skip, take: take, sort: sort, sortOrder: sortOrder, microsite: microsite, category: category } })
                .then(function (results) {
                    deferred.resolve(results.data);
                }).catch();

            return deferred.promise;
        }

        

        function trackClick(query, hitId, trackId, hitPos) {
            var deferred = $q.defer();

            $http.get('/api/search/trackclick', { params: { query: query, hitId: hitId, trackId: trackId, hitPos: hitPos } })
                .then(function (results) {
                    deferred.resolve(results.data);
                }).catch();

            return deferred.promise;
        }

    }
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/factories/_searchService.js
// module id = 6
// module chunks = 0